import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { programProfile, Session } from '../../../../services/session.service';
import { MatIcon } from '@angular/material/icon';
import { MatMenuItem } from '@angular/material/menu';
import { RouterLinkActive, RouterLink } from '@angular/router';
import { NgTemplateOutlet } from '@angular/common';
import {AppConstants} from "../../../../app-constants";

@Component({
    selector: 'app-program-profile',
    templateUrl: './program-profile.component.html',
    styleUrls: ['./program-profile.component.scss'],
    imports: [MatIcon, MatMenuItem, RouterLinkActive, RouterLink, NgTemplateOutlet]
})
export class ProgramProfileComponent implements OnInit {

  @Input() profiles: programProfile[];
  @Input() annualUpdate: boolean = false;

  @Output() closeMenu: EventEmitter<boolean> = new EventEmitter<boolean>();
  institutionRequestKeys: string[] = [];

  annualUpdateLabels: string[] = [AppConstants.AnnualUpdatesDefaultCaption];
  links: uiparams[] = [];

  private readonly session:Session = inject(Session);

  constructor() { }

  ngOnInit(): void {
    if(this.profiles && this.profiles.length > 0 ) {
      this.institutionRequestKeys = this.profiles.map( p => p.institutionRequestKey ).filter( this.onlyUnique );
      this.annualUpdateLabels = [];
      for( let institutionRequestKey of this.institutionRequestKeys ) {
        const profiles = this.profiles.filter( p => p.institutionRequestKey === institutionRequestKey );
        if( profiles.length !== 1 ) {
          this.links.push( {
            institutionRequestKey: institutionRequestKey,
            activeTab: 1,
            accreditorName: profiles[ 0 ].accreditorName,
          } )
          this.annualUpdateLabels.push( this.session.getAnnualUpdateLabelOfDirectoryProgram(profiles[ 0 ].institutionRequestKey) );
        } else {
          profiles.forEach( p => {
            this.links.push( {
              institutionRequestKey: institutionRequestKey,
              programRequestKey: p.directoryProgramRequestKey,
              activeTab: this.annualUpdate ? 5 : 1,
              accreditorName: p.accreditorName
            } )
            this.annualUpdateLabels.push( this.session.getAnnualUpdateLabelOfDirectoryProgram(p.directoryProgramRequestKey) );
          } );
        }
      }
    }
  }

   onlyUnique(value, index, array) {
    return array.indexOf(value) === index;
  }

}

interface uiparams {
  institutionRequestKey: string,
  programRequestKey?: string,
  activeTab: number,
  accreditorName?: string
}
